import { createContext, useContext } from "react";
import type { UseConnectionStoreReturn } from "./useConnectionStore";

export const ConnectionStoreContext = createContext<UseConnectionStoreReturn | null>(null);

export function useConnectionSession(): UseConnectionStoreReturn {
  const store = useContext(ConnectionStoreContext);
  if (!store) {
    throw new Error("useConnectionSession must be used within ConnectionProvider");
  }
  return store;
}

/**
 * The view identity for connection-scoped GraphQL operations: the active
 * connectionId, "fixtures" in demo/fixture mode, or null when no connection is
 * resolved yet (callers should skip). Pass it as the `viewKey` variable on
 * every connection-scoped operation — the Apollo cache partitions on it and
 * the auth link derives transport headers from it (see graphql/apollo.ts).
 *
 * Lenient outside ConnectionProvider (returns null, so data hooks skip):
 * "no provider" and "no connection resolved yet" mean the same thing to a
 * consumer, and component tests render subtrees without the provider.
 */
export function useViewKey(): string | null {
  const store = useContext(ConnectionStoreContext);
  if (!store) return null;
  return store.state.provider === "fixtures" ? "fixtures" : store.state.activeConnectionId;
}
